import { render, staticRenderFns } from "./msgDetail.vue?vue&type=template&id=8a51eea6&scoped=true"
import script from "./msgDetail.vue?vue&type=script&lang=js"
export * from "./msgDetail.vue?vue&type=script&lang=js"
import style0 from "./msgDetail.vue?vue&type=style&index=0&id=8a51eea6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a51eea6",
  null
  
)

export default component.exports